// src/slices/shipcomapany/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getShipCompanies, getShipCompanyOne } from "./thunk";

const initialState = { shipCompanies: [], shipCompanyOne: null, loading: false, error: null };

const shipCompanySlice = createSlice({
  name: "shipCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // GET ALL
      .addCase(getShipCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShipCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.shipCompanies = action.payload?.data || [];
      })
      .addCase(getShipCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET ONE
      .addCase(getShipCompanyOne.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShipCompanyOne.fulfilled, (state, action) => {
        state.loading = false;
        state.shipCompanyOne = action.payload?.data || action.payload;
      })
      .addCase(getShipCompanyOne.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default shipCompanySlice.reducer;
